import apiClient from './apiClient';

export interface LookupResult {
  code: string;
  name: string;
}

export interface LookupSearchResult {
  data: LookupResult[];
  total: number;
  page: number;
  size: number;
}

/**
 * Shared lookup API — resolves reference table codes to display names.
 *
 * Supported lookupType values:
 *   employee, customer, department, currency, paymentTerms,
 *   packing, tradeTerms, remarkTemplate, color, testCode, expenseCode,
 *   product, warehouse, supplier, grade, leaveType, purchaseOrder,
 *   salesContract, packingCustomer, level, purchaseReceipt, sampleAnalysis,
 *   contractorCode, colorBatch, rdPurchaseOrder,
 *   position, bonusType, docCategory, salaryCode, shippingNotice,
 *   sampleRequest, processCode, inventoryCategory, transferReason,
 *   complaintReason, defectCause, inspectionOrder
 */
export const lookupApi = {
  async getName(lookupType: string, code: string): Promise<LookupResult> {
    if (!code) return { code: '', name: '' };
    const res = await apiClient.get(
      `/api/lookup/${encodeURIComponent(lookupType)}/${encodeURIComponent(code)}`,
    );
    return res.data;
  },

  async getProductInfo(pk1: string, pk2: string): Promise<{ unit: string; unitType: string; name: string }> {
    if (!pk1) return { unit: '', unitType: '', name: '' };
    const res = await apiClient.get(
      `/api/lookup/product-info?pk1=${encodeURIComponent(pk1)}&pk2=${encodeURIComponent(pk2)}`,
    );
    return res.data;
  },

  async search(lookupType: string, keyword?: string, page = 1, size = 20): Promise<LookupSearchResult> {
    const params = new URLSearchParams();
    if (keyword) params.set('keyword', keyword);
    params.set('page', String(page));
    params.set('size', String(size));
    const res = await apiClient.get(
      `/api/lookup/${encodeURIComponent(lookupType)}?${params.toString()}`,
    );
    return res.data;
  },
};
